/**
 * What « Faire » opens on a ritual (21/10/2026, « il ouvre son travail »): its
 * existing route says where the work is ready. An app opens the séance of its
 * objects still to handle, the two scopes of Mon travail open the team's week
 * or the review of the apps; any other page opens as it is; none opens the chat.
 */
export const TEAM_ROUTE = '/tasks?portee=equipe';
export const COMPANY_ROUTE = '/tasks?portee=entreprise';

export type RitualTarget =
  | { kind: 'app'; appKey: string }
  | { kind: 'team' }
  | { kind: 'company' }
  | { kind: 'route'; to: string }
  | { kind: 'chat' };

export const ritualTarget = (route: string | null | undefined): RitualTarget => {
  if (!route) return { kind: 'chat' };
  const app = /^\/apps\/([^/?#]+)\/?$/.exec(route);
  if (app?.[1]) return { kind: 'app', appKey: decodeURIComponent(app[1]) };
  const url = new URL(route, 'https://domino.local');
  if (url.pathname === '/tasks') {
    const scope = url.searchParams.get('portee');
    if (scope === 'equipe') return { kind: 'team' };
    if (scope === 'entreprise') return { kind: 'company' };
  }
  return { kind: 'route', to: route };
};

export const appRoute = (appKey: string): string => `/apps/${encodeURIComponent(appKey)}`;
